import React, { Fragment } from 'react';

import { FilterIconWithHint } from 'modules/queues/common/components/AppointmentsFilter';
import FiltersPopover from './components/FiltersPopover';


const FiltersAccordeonGroup = ({
  activeFilters,
  iconTooltipMessage,
  resetAllAccordeonFilters,
  anchorEl,
  openPopover,
  closePopover,
}) => (
  <Fragment>
    <FilterIconWithHint
      activeFilters={ activeFilters }
      popoverOpened={ !!anchorEl }
      openPopover={ openPopover }
      iconName="filter-lines"
      iconTooltipMessage={ iconTooltipMessage }
      lastChild
    />

    <FiltersPopover
      popoverOpened={ !!anchorEl }
      closePopover={ closePopover }
      resetAllAccordeonFilters={ resetAllAccordeonFilters }
    />
  </Fragment>
);

export default FiltersAccordeonGroup;
